export default __webpack_public_path__ + "static/media/pos-bill-list.e3379667.jpg";